import Router from 'next/router'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { StripeProvider, Elements } from 'react-stripe-elements'

import SectionWrapper from 'components/SectionWrapper'
import { cartSuccess, cartFail } from 'routes'
import { Row } from 'styles/components/layout'
import { openCloudPaymentsWidget } from 'components/_special/CloudPaymentWidget/'
import injectSource from 'utils/client/injectSource'

import CartFormEurope from '../CartFormEurope'
import CartFormRussia from '../CartFormRussia'

import { Wrapper, ColStyled, FormBlock } from './styles'

const { STRIPE_PAYMENT_KEY } = process.env.server

class CartFormCommon extends Component {
  constructor(props) {
    super(props)

    this.state = {
      stripe: null,
      isPaymentSucceed: null,
    }
  }

  componentDidMount() {
    const { sales } = this.props

    if (!STRIPE_PAYMENT_KEY) {
      return false
    }
    if (window.Stripe) {
      this.setState({ stripe: window.Stripe(sales._paymentKey) }) // eslint-disable-line react/no-did-mount-set-state
    } else {
      if (injectSource('https://js.stripe.com/v3/', 'stripe-js')) {
        document.querySelector('#stripe-js').addEventListener('load', () => {
          // Create Stripe instance once Stripe.js loads
          this.setState({ stripe: window.Stripe(sales._paymentKey) })
        })
      }
    }
  }

  successOrderCb = () => {
    const {
      locale,
      cart: { redirectUrl },
    } = this.props
    if (redirectUrl) {
      return window.location.replace(redirectUrl)
    }
    Router.push(cartSuccess.link(locale), cartSuccess.as(locale))
  }

  failureOrderCb = () => {
    const { locale } = this.props
    Router.push(cartFail.link(locale), cartFail.as(locale))
  }

  componentDidUpdate(prevProps) {
    const { cart, locale, dict, sales } = this.props
    if (cart.invoiceId === prevProps.cart.invoiceId && cart.redirectUrl === prevProps.cart.redirectUrl) {
      return
    }

    if (locale === 'ru') {
      if (cart.invoiceId && !cart.redirectUrl) {

          const invoiceId = cart.invoiceId
          const amount = cart.sum.cost

          openCloudPaymentsWidget({
            dict,
            cart,
            invoiceId,
            amount,
            sales,
          })

      }

      if (cart.redirectUrl && !prevProps.cart.redirectUrl) {
        window.location.replace(cart.redirectUrl)
      }
    }
  }

  renderForm = () => {
    const {
      russiaPayment,
      russiaCollectData,
      europeCollectData,
      collectDataReset,
      europePayment,
      hideCheckoutButton,
      registerCheckoutHandler,
      registerOfferError,
    } = this.props
    const { stripe } = this.state

    return STRIPE_PAYMENT_KEY ? (
      <StripeProvider stripe={stripe}>
        <Elements>
          <CartFormEurope
            handleSuccess={this.successOrderCb}
            handleFailure={this.failureOrderCb}
            handleCollect={europeCollectData}
            handleCollectReset={collectDataReset}
            handlePayment={europePayment}
            {...this.props}
          />
        </Elements>
      </StripeProvider>
    ) : (
      <CartFormRussia
        handleCollect={russiaCollectData}
        handleCollectReset={collectDataReset}
        handleSuccess={this.successOrderCb}
        handleFailure={this.failureOrderCb}
        handlePayment={russiaPayment}
        isPaymentSucceed={this.state.isPaymentSucceed}
        hideCheckoutButton={hideCheckoutButton}
        registerCheckoutHandler={registerCheckoutHandler}
        registerOfferError={registerOfferError}
        {...this.props}
      />
    )
  }

  render() {
    const { isEmbedded } = this.props

    if (isEmbedded) {
      return this.renderForm()
    }

    return (
      <SectionWrapper isWideToDesktop={true}>
        <Wrapper className="container-fluid">
          <Row>
            <ColStyled width={{ xs: 1, lg: 8 / 12 }}>
              <FormBlock>
                {this.renderForm()}
              </FormBlock>
            </ColStyled>
          </Row>
        </Wrapper>
      </SectionWrapper>
    )
  }
}

CartFormCommon.propTypes = {
  cart: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  sales: PropTypes.object.isRequired,
  dict: PropTypes.object.isRequired,
  russiaPayment: PropTypes.func.isRequired,
  russiaCollectData: PropTypes.func.isRequired,
  europeCollectData: PropTypes.func.isRequired,
  collectDataReset: PropTypes.func.isRequired,
  europePayment: PropTypes.func.isRequired,
  redirectUrl: PropTypes.string,
  hideCheckoutButton: PropTypes.bool,
  isEmbedded: PropTypes.bool,
  registerCheckoutHandler: PropTypes.func,
  registerOfferError: PropTypes.func,
}

CartFormCommon.defaultProps = {
  hideCheckoutButton: false,
  isEmbedded: false,
  registerCheckoutHandler: null,
  registerOfferError: null,
}

export default CartFormCommon
